import appMixin from "../mixins/app-mixin";
import vuexStoreFactory from "@/_util/vuex-store-factory"
import appConfig from "../app.config";
import axios from "axios";
import appOauthMixin from "./app-oauth-mixin";

let factory = new vuexStoreFactory();
var mixin = factory.generateVuexNamespacedMixin(appConfig.store, appConfig.namespace);

var computedList = { ...mixin.computed };
Object.keys(appConfig).forEach((e) => {
  computedList[e] = { get: () => appConfig[e] };
});

export default
{
  mixins: [appMixin, appOauthMixin],
    data: () => ({
      requestCall: null,
      requests: [],
      userRole: "",
      isAllUsers: false,
      isCMUsers:false,
      isAdmin:false,
      rolePriorities: {
        "Admin": 1,
        "CMUsers": 2,  // Higher priority
        "AllUsers": 3, // Lower priority
        // Add other roles as needed
      },
    }),
    methods : {
        async getPeople()
        {
            return await this._request(`${this.settings.apiUrl}/api/People`);
        },
        
        //Core method for managing API Requests
        async _request(url, options) {
          const axiosSource = axios.CancelToken.source();
          this.requestCall = { cancel: axiosSource.cancel, msg: "Loading..." };
          var config = Object.assign(
            {
              method: "get",
              url: this.settings.apiUrl+url,
              data: null,
              headers: this.requestHeaders,
              withCredentials: false,
              cancelToken: axiosSource.token,
            },
            options
          );
          try {
           
            return await axios(config);
          } catch (err) {
            console.error(err);
            throw err;
          }
        },
        cancel() { //For canceling the old api calls
          this.requestCall.cancel();
          this.clearOldRequest("Cancelled");
        },
        clearOldRequest(msg) {
          this.requestCall.msg = msg;
          this.requests.push(this.requestCall);
          this.requestCall = null;
        },
    //     async getUser()
    //     {
    //           var ts = this;
           
    //   await axios({
    //     method: "get",
    //     url: ts.settings.apiUrl + "/UserContext/GetUser",
        
    //         withCredentials: true,
    //         headers: ts.requestHeaders,
          
    //   })
    //     .then(function (response) {
    //       console.log("res->",response.data); 

    //       let highestPriority = Infinity;
          
    //       response.data.role.forEach(role => {
    //         console.log("res->",role); 
    //           if (ts.rolePriorities[role] < highestPriority) {
    //             ts.userRole = role;
    //             highestPriority = ts.rolePriorities[role];
    //           }
    //         });
          
    //         console.log("highestPriority ->",highestPriority);
    //         if (highestPriority  != null) {
                  
    //           switch (highestPriority) {
    //             case 1:
    //               ts.isAdmin = true;
    //             break;
    //             case 2:
    //               ts.isCMUsers = true;
    //             break;
    //             case 3:
    //               ts.isAllUsers = true;
    //             break;
    //             default:
    //               ts.isAllUsers = true;
    //               break;
    //             }
    //     }
    // //  alert(highestPriority)
    //     })
    //     .catch(function (error) {
    //       console.log("Error! Could not reach the API. " + error);
    //     });
    //    // alert( ts.isCMUsers) 
    //   },
    },
    computed: {
      ...computedList,
      isLoggedIn() {
        return !!this.credentials;
      },      
      requestHeaders() {
          var returnValue = {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,POST,OPTIONS,DELETE,PUT",
            "Access-Control-Allow-Headers": "x-ms-*,content-*"
          };
        if (!!this.credentials) {
            returnValue[
              "Authorization"
            ] = `bearer ${this.credentials.access_token}`;
          } else {
            console.warn('[Request Headers] No credentials available for authorization header');
          }
          return returnValue;
        },
      }
    
}